import { render, staticRenderFns } from "./TipoCargaForm.vue?vue&type=template&id=384f4840"
import script from "./TipoCargaForm.vue?vue&type=script&lang=js"
export * from "./TipoCargaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports